import { default as domainScenario } from './scenario/routes'

export default [
    ...domainScenario
]
